import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Caché del módulo: las tablas del registro y los municipios de cada provincia no cambian mientras la página está
// abierta, así que se piden una vez y las comparten todos los componentes (el titular y el segundo conductor, cada
// vuelta al paso de datos, cada vez que se abre un diálogo). Un fallo no se guarda: se vuelve a pedir al reintentar.
const promesas = new Map();
const resueltas = new Map();
function pedir(url, valida) {
  if (!promesas.has(url)) {
    const promesa = api.get(url).then(({ data }) => {
      if (!valida(data)) throw new Error("respuesta no válida");
      resueltas.set(url, data);
      return data;
    });
    promesa.catch(() => { if (promesas.get(url) === promesa) promesas.delete(url); });
    promesas.set(url, promesa);
  }
  return promesas.get(url);
}
const urlTablas = (admin) => (admin ? "/admin/registry/refdata" : "/public/registry/refdata");
const urlMunicipios = (prov) => `/public/registry/municipalities/${prov}`;
const sonTablas = (d) => Array.isArray(d?.countries);
// Los municipios del INE de una provincia («08»): una promesa con la lista (falla si no llega una lista).
export const municipiosDe = (prov) => pedir(urlMunicipios(prov), Array.isArray);
// Lo que ya ha llegado, sin esperar (para no enseñar «Cargando…» al volver a montar).
export const municipiosYaCargados = (prov) => resueltas.get(urlMunicipios(prov)) || null;
// Para los tests: cada uno empieza sin nada guardado.
export function olvidarCache() {
  promesas.clear();
  resueltas.clear();
}

// Tablas del registro de viajeros (países, vías, carnés…). En el panel, también marcas y colores de los vehículos.
// Devuelve `null` mientras carga, las tablas cuando llegan y `{ failed: true, retry }` si no se han podido cargar
// (`refdata?.countries` sigue dando `undefined`; los campos del registro lo avisan con `AvisoTablas`).
export function useRegistryRefdata(admin = false) {
  const [data, setData] = useState(() => resueltas.get(urlTablas(admin)) || null);
  const [intento, setIntento] = useState(0);
  useEffect(() => {
    let vivo = true;
    pedir(urlTablas(admin), sonTablas)
      .then((d) => { if (vivo) setData(d); })
      .catch(() => {
        if (vivo) setData({ failed: true, retry: () => { setData(null); setIntento((n) => n + 1); } });
      });
    return () => { vivo = false; };
  }, [admin, intento]);
  return data;
}
